import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ShareAndroid = createSvgIcon(
  <path d="M18 .75a4.5 4.5 0 0 0-4.426 5.318L9.11 8.748a4.5 4.5 0 1 0 0 6.505l4.464 2.678a4.5 4.5 0 1 0 .958-2.05l-4.235-2.54a4.5 4.5 0 0 0 0-2.682l4.235-2.541A4.5 4.5 0 1 0 18 .75Zm-2.25 4.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM18 16.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5ZM3.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z" />,
  'ShareAndroid'
);

export { ShareAndroid };